import DOMPurify from 'dompurify';

/** In addition to sanitizing, every caller uses a scriptless/formless sandbox. */
export function draftPreviewDocument(
  html: string,
  sharedCss = '',
  css = '',
): string {
  const safe = DOMPurify.sanitize(html, {
    WHOLE_DOCUMENT: true,
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'base'],
    FORBID_ATTR: ['srcdoc'],
  });
  const styles = `<style>${`${sharedCss}\n${css}`.replace(/<\/style/gi, '<\\/style')}</style>`;
  return safe.includes('</head>')
    ? safe.replace('</head>', `${styles}</head>`)
    : `<!doctype html><html><head><meta name="referrer" content="no-referrer">${styles}</head><body>${safe}</body></html>`;
}
